import styles from "../../PPTPlugin/PPTInstallGuidePage.module.css";
import React, {useEffect} from "react";
import {
    PPT_INSTALL_STEP4_TITLE, SIGN_IN_TEXT,
    YUJA_TITLE,
} from "../../../utils/constants";

import {useConfig} from "../../../hooks/useConfig";
import {ReactComponent as STEP_1}   from "./images/step_1_img.svg";
import {ReactComponent as STEP_2}   from "./images/step_2_img.svg";
import {ReactComponent as STEP_3}   from "./images/step_3_img.svg";
import {ReactComponent as STEP_4}   from "./images/step_4_img.svg";
import YuJaButton from "../../../components/standardization/YuJaButton";
import {
    getShortName,
    isChromiumBrowser,
    isFirefoxBrowser,
    isSafariBrowser, sendMessageToExtension,
} from "../../../utils/helpers";
import {useSession} from "../../../hooks/useSession";
import SupportedBrowserList from "./SupportedBrowserList";


export default function GoogleSlidesIntegrationPage() {
    const config = useConfig();
    const {getSession, parseSessionToken} = useSession();


    const onOpen = () => {
        let extensionConfig = config.google_slides_extension;

        if (isChromiumBrowser()) {
            window.open(extensionConfig.chrome);
        } else if (isFirefoxBrowser()) {
            window.open(extensionConfig.firefox);
        } else if (isSafariBrowser()) {
            window.open(extensionConfig.safari);
        }
    }

    useEffect(() => {
        let {authorization} = getSession();
        let {institutionId } = parseSessionToken();
        let shortName = getShortName();

        const messageObj = {
            type: "ENGAGE_AUTH_LOGIN",
            enforced: false,
            zone: config.zone,
            shortName: shortName,
            token: authorization,
            institutionId
        };



        let intervalId = setInterval(() => sendMessageToExtension(config.chrome_extension_id, messageObj), 1000);

        return () => {
            if (!!intervalId) {
                clearInterval(intervalId);
            }
        }
    }, []);

    return (
        <>

            <div style={{height: 10}}/>
            <div className={styles.starterBanner}>
                <div className={styles.column} style={{flex: 1, minWidth: 470, gap: 25}}>
                    <span>{"Set up your YuJa Engage Google Slides Experience"}</span>
                    <span className={styles.description} style={{"color": "#4A4A4A"}}>
                        {"Follow the steps below to integrate Engage with Google Slides."}
                    </span>
                </div>
            </div>
            <div style={{height: 30}}/>
            <div className={styles.column} style={{gap: 20}}>
                {(isChromiumBrowser() || isFirefoxBrowser() || isSafariBrowser())
                    ? (
                        <div className={styles.stepCard}>
                            <div className={styles.stepNo}>1</div>
                            <div className={styles.column} style={{gap: 10, flex: 1}}>
                                <span style={{whiteSpace: "nowrap"}}>{"Install YuJa Engage Browser Extension"}</span>
                                <div className={styles.description}>
                                    {isChromiumBrowser() && "Download the Engage Google Slides Browser Extension from the Chrome Web Store."}
                                    {isFirefoxBrowser() && "Download the Engage Google Slides Browser Extension from the Firefox Add-ons site."}
                                    {isSafariBrowser() && "Download the Engage Google Slides Browser Extension from the App Store."}
                                </div>
                                <YuJaButton style={{height: 36, marginTop: 15}} onClick={onOpen}>
                                    {"Install Extension"}
                                </YuJaButton>
                            </div>
                            <STEP_1 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                        </div>
                    )
                    : (
                        <div className={styles.stepCard} style={{minHeight: 150}}>
                            <div className={styles.stepNo}>1</div>
                            <div className={styles.column} style={{gap: 10, flex: 1}}>
                                <span style={{whiteSpace: "nowrap"}}>{"Install YuJa Engage Browser Extension"}</span>
                                <div className={styles.description}>
                                    {"Your current browser is not supported. Please use one of the supported browsers to download the extension:"}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Chrome</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Firefox</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Safari</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Opera</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Brave</span>
                                    {","}
                                    <span style={{marginLeft: 3, fontWeight: "700"}}>Edge</span>
                                </div>
                            </div>
                            <SupportedBrowserList/>
                        </div>
                    )
                }

                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>2</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{"Locate YuJa Engage in Your Presentation"}</span>
                        <span className={styles.description}>
                            {"Open your presentation in Google Slides, and locate the"}
                            <strong style={{margin: "0 3px"}}>{YUJA_TITLE}</strong>
                            {"tab in the top menu bar."}
                        </span>
                    </div>
                    <div style={{flex: 1}}/>
                    <STEP_2 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                </div>

                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>3</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{"Sign In to Your Engage Account"}</span>
                        <span className={styles.description}>
                            {"Select"}
                            <strong style={{margin: "0 3px"}}>{YUJA_TITLE}</strong>
                            {">"}
                            <strong style={{margin: "0 3px"}}>{SIGN_IN_TEXT}</strong>
                            {", and enter your Engage credentials to access your activities."}
                        </span>
                    </div>
                    <div style={{flex: 1}}/>
                    <STEP_3 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                </div>


                <div className={styles.stepCard}>
                    <div className={styles.stepNo}>4</div>
                    <div className={styles.column} style={{gap: 10, flex: 1, minWidth: 250}}>
                        <span style={{whiteSpace: "nowrap"}}>{PPT_INSTALL_STEP4_TITLE}</span>
                        <span
                            className={styles.description}>{"Once signed in, you can create or insert your activities into your Google Slides presentation."}</span>
                    </div>
                    <div style={{flex: 1}}/>
                    <STEP_4 style={{width: 340, height: 220, marginLeft: "auto"}}/>
                </div>

                {/*<span*/}
                {/*    style={{*/}
                {/*        display: "flex",*/}
                {/*        fontSize: 14,*/}
                {/*        lineHeight: "160%",*/}
                {/*        color: "#191520",*/}
                {/*        alignSelf: "center",*/}
                {/*        alignItems: "center"*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <QUESTION_MARKER style={{marginRight: 5, width: 32, height: 32}}/>*/}
                {/*    {NEED_HELP_TEXT}*/}
                {/*    <span*/}
                {/*        tabIndex={0}*/}
                {/*        className={styles.link}*/}
                {/*        style={{marginLeft: 5}}*/}
                {/*        onClick={() => window.open(YUJA_SUPPORT_LINK)}*/}
                {/*    >{"YuJa Support"}</span>*/}
                {/*</span>*/}

            </div>
        </>
    );
}